import { AfterViewInit, Component, inject, OnDestroy, OnInit, OutputEmitterRef, Signal, TemplateRef } from '@angular/core';

import { _SectionDetailsComponent } from 'src/app/infrastructure/components/section-components/_section-details-component';
import { IFooterData } from 'src/app/features/shared/footer/models/footer-data';
import { IHeaderData } from 'src/app/features/shared/header/models/header-data';
import { InputControlComponent } from 'src/app/features/shared/controls/container/input-control/input-control.component';
import { SharedModule } from 'src/app/features/shared/shared.module';
import { FormComponent } from 'src/app/features/shared/form/container/form.component';
import { HttpParams } from '@angular/common/http';
import { _CentralPageService } from 'src/app/features/shared/central-page/services/_central-page.service';
import { _FormModelService } from 'src/app/infrastructure/services/model-services/_form-model.service';
import { _PageService } from 'src/app/infrastructure/services/page-services/_page.service';
import { EMPTY } from 'rxjs';
import { ActivatedRouteService } from 'src/app/infrastructure/services/route-service/activated-route.service';
import { routePage } from 'src/app/infrastructure/services/route-service/models/route-page';
import { FooterService } from 'src/app/features/shared/footer/footer.service';
import { HeaderService } from 'src/app/features/shared/header/services/header.service';
import { LoadingPageService } from 'src/app/infrastructure/services/loading-services/loading-page.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { IUserDto } from 'src/assets/common/models/user-dto.g';
import { IAccountData, accountData } from '../../models/account-data';
import { IAccountForm } from '../../models/account-form';
import { CLAIM_PAGE } from 'src/app/infrastructure/injection-tokens/PAGE-NAME';
import { pageSectionName } from 'src/app/infrastructure/services/page-services/models/page-section-name';

@Component({
    selector: 'app-account-details',
    templateUrl: './account-details.component.html',
    styleUrls: [
    ],
    standalone: true,
        providers: [
            // skipSelf-fallback: HomeComponent provide't CLAIM_PAGE inmiddels zelf al (vroege
            // tab-footer-auth-registratie, zie _TabPageRouteComponent._ngOnInit).
            { provide: CLAIM_PAGE, useFactory: () => inject(CLAIM_PAGE, { skipSelf: true, optional: true }) ?? pageSectionName.accountDetails },
        ],
    imports: [
        FormComponent,
        InputControlComponent,
        SharedModule,
    ],
})
export class AccountDetailsComponent
    extends _SectionDetailsComponent<IUserDto, IAccountData, IAccountForm>
    implements AfterViewInit, OnInit, OnDestroy
{
    protected override readonly _activatedRouteService = injectRequired(ActivatedRouteService);
    protected override readonly _centralPageService = injectRequired(_CentralPageService);
    protected override readonly _footerService = injectRequired(FooterService);
    protected override readonly _formModelService = injectRequired(_FormModelService);
    protected override readonly _headerService = injectRequired(HeaderService);
    protected override readonly _loadingPageService = injectRequired(LoadingPageService);
    protected override readonly _pageService = injectRequired(_PageService);

    override out_onDelete = this._out_onDelete;
    override out_onDirty$$ = this._out_onDirty;
    override out_onEnter$$ = this._out_onEnter;
    override out_onEscape = this._out_onEscape;
    override out_onFormReset$$ = this._out_onFormReset;
    override out_onPageLoaded = this._out_onPageLoaded;

    override autoFocus$$ = this._input_AutoFocus$$;
    override dataModel$$ = this._dataModel$$;
    override form$$ = this._form$$;
    override formControls$$ = this._formControls$$;
    override showError$$ = this._showError$$;
    override template_footerLeft$$ = this._template_footerLeft$$;
    override template_sectionDetails_extraButtons$$ = this._template_sectionDetails_extraButtons$$;
    override template_sectionEdit_extraButtons$$ = this._template_sectionEdit_extraButtons$$;

    override footerData: Partial<IFooterData> = {
        hideSideBlockLeft: false,
        hideSideBlockRight: false,
    };
    override headerData: Partial<IHeaderData> = {
        sideBlockLeft_noClick: true,
        title: 'details ' + routePage.account,
    };
    override onDelete_httpParams: HttpParams = new HttpParams();
    override onDelete_requestOptions: any = null;

    value_correspondenceName = this.dataModel$$()?.[accountData.correspondenceName];
    value_email = this.dataModel$$()?.[accountData.email];
    value_firstName = this.dataModel$$()?.[accountData.firstName];
    value_lastName = this.dataModel$$()?.[accountData.lastName];
    value_applicationName = this.dataModel$$()?.[accountData.applicationName];

    override ngOnInit(): void {
        super._ngOnInit();
    }

    protected override _delete_http$() { return EMPTY; }

    override emit_onDelete(): void {
        super._delete();
    }

    override emit_onEnter(): void {
        super._emit_onEnter();
    }

    override emit_onEscape(): void {
        super._emit_onEscape();
    }

    override emit_pageLoaded(): void {
        super._emit_pageLoaded();
    }

    override form_reset(): void {
        super._form_reset();
    }

    override ngAfterViewInit(): void {
        super._ngAfterViewInit();
    }

    override ngOnDestroy(): void {
        super._ngOnDestroy();
    }
}
